import {
	EnhancedButtonPrimeReact,
	EnhancedButtonPrimeReactSeverity,
	EnhancedDropDownRHFWithLabel,
	LabelPosition,
	RHookFormDatePicker,
} from "@websential/cosmic-v20";
import { Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";

interface IRemittedRemittanceTransacitonsHeader {
	clientsDDL: any,
	accountantDDL: any,
	frequencyDDL: any,
	remittanceYearDDL: any,
	remittanceMonthDDL: any,
	onAccountantSelectionChangeHandler: (value: any) => void
	setStateRunGetListAPICall: (value: boolean) => void
}

export const RemittedRemittanceTransacitonsHeader: React.FC<
	IRemittedRemittanceTransacitonsHeader
> = ({ accountantDDL, onAccountantSelectionChangeHandler, clientsDDL, frequencyDDL, remittanceYearDDL, remittanceMonthDDL, setStateRunGetListAPICall }) => {

	return (
		<>
			<Grid
				container
				size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
				sx={{
					background: "#fff",
					border: "1px solid #e5e7eb",
					borderBottom: 0,
					borderRadius: "2px 2px 0 0",
					padding: "31px 20px 1rem 20px",
					marginBottom: "0px!important",
				}} columnSpacing={2}>
				<Grid size={{ xs: 12, sm: 12, md: 2.5, lg: 2.5, xl: 2.5 }}>
					<EnhancedDropDownRHFWithLabel
						selectName={"accountant"}
						items={accountantDDL ?? []}
						selectedItem={"all"}
						label={"Accountant Name"}
						testId={"cleint-ddl"}
						onSelectionChangeHandler={onAccountantSelectionChangeHandler}
					/>
				</Grid>
				<Grid size={{ xs: 0.5, sm: 0.5, md: 0.5, lg: 0.5, xl: 0.5 }}></Grid>
				<Grid size={{ xs: 12, sm: 12, md: 2.5, lg: 2.5, xl: 2.5 }}>
					<EnhancedDropDownRHFWithLabel
						selectName={"client"}
						items={clientsDDL ?? []}
						selectedItem={"all"}
						label={"Client Name"}
						testId={"cleint-ddl"}
					/>
				</Grid>
				<Grid size={{ xs: 0.5, sm: 0.5, md: 0.5, lg: 0.5, xl: 0.5 }}></Grid>
				<Grid
					size={{ xs: 12, sm: 12, md: 2.5, lg: 2.5, xl: 2.5 }}
				>
					<EnhancedDropDownRHFWithLabel
						selectName={"clientType"}
						items={[
							{
								label: "All",
								value: "all",
							},
							{
								label: "Test",
								value: 200,
							},
							{
								label: "Live",
								value: 100,
							}
						]}
						label={"Client Type"}
						testId={"client-type"}
						selectedItem={"all"}
						onSelectionChangeHandler={() => setStateRunGetListAPICall(false)}
					/>


				</Grid>
				<Grid size={{ xs: 0.5, sm: 0.5, md: 0.5, lg: 0.5, xl: 0.5 }}></Grid>
				<Grid
					size={{ xs: 12, sm: 12, md: 2.5, lg: 2.5, xl: 2.5 }}
				>
					<EnhancedDropDownRHFWithLabel
						selectName={"frequency"}
						items={frequencyDDL ?? []}
						label={"Frequency"}
						testId={"frequency"}
						selectedItem={"all"}
						onSelectionChangeHandler={() => setStateRunGetListAPICall(false)}
					/>
				</Grid>

				<Grid size={{ xs: 0.5, sm: 0.5, md: 0.5, lg: 0.5, xl: 0.5 }}></Grid>
				<Grid container size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
					<Grid
						size={{ xs: 12, sm: 12, md: 2.5, lg: 2.5, xl: 2.5 }}
					>
						<EnhancedDropDownRHFWithLabel
							selectName={"remittanceYear"}
							items={remittanceYearDDL ?? []}
							label={"Remittance Year"}
							testId={"remittanceYear"}
							selectedItem={"all"}
							onSelectionChangeHandler={() => setStateRunGetListAPICall(false)}
						/>
					</Grid>
					<Grid size={{ xs: 0.5, sm: 0.5, md: 0.5, lg: 0.5, xl: 0.5 }}></Grid>
					<Grid
						size={{ xs: 12, sm: 12, md: 2.5, lg: 2.5, xl: 2.5 }}
					>
						<EnhancedDropDownRHFWithLabel
							selectName={"remittanceMonth"}
							items={remittanceMonthDDL ?? []}
							label={"Remittance Month"}
							testId={"remittanceMonth"}
							onSelectionChangeHandler={() => setStateRunGetListAPICall(false)}
							selectedItem={remittanceMonthDDL && remittanceMonthDDL[new Date().getMonth()].value}
						/>
					</Grid>
					<Grid size={{ xs: 0.5, sm: 0.5, md: 0.5, lg: 0.5, xl: 0.5 }}></Grid>
					{/* <Grid
						size={{ xs: 12, sm: 12, md: 2.5, lg: 2.5, xl: 2.5 }}
					>
						<RHookFormDatePicker
							name="startDate"
							testId="start-date"
							label="Date In"
							// labelPosition={LabelPosition.Top}
							format="M dd, yy"
							onDateSelectionChangeHandler={() => setStateRunGetListAPICall(false)}
						/>
					</Grid>
					<Grid
						size={{ xs: 0.5, sm: 0.5, md: 0.5, lg: 0.5, xl: 0.5 }}
						sx={{ maxWidth: "82px", textAlign: "center", paddingTop: "30px" }}
					>
						<span style={{
							fontSize: "0.875rem",
							fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
							fontWeight: 500,
							letterSpacing: "0.00714em",
							color: "rgba(0, 0, 0, 0.6)",
							// paddingTop:"1.4rem"
						}}>to</span>
					</Grid>
					<Grid
						size={{ xs: 12, sm: 12, md: 2.5, lg: 2.5, xl: 2.5 }}
						sx={{
							"& .MuiGrid-root .MuiFormLabel-root": { marginTop: "24px!important", },
						}}
					>
						<RHookFormDatePicker
							name="endDate"
							testId="end-date"
							label=""
							// labelPosition={LabelPosition.Top}
							format="M dd, yy"
							onDateSelectionChangeHandler={() => setStateRunGetListAPICall(false)}
						/>
					</Grid> */}

				</Grid>
				<Grid size={{ xs: 12, sm: 12, md: 2.5, lg: 2.5, xl: 2.5 }}>
					<EnhancedButtonPrimeReact
						label="Apply Filter"
						raised
						type="submit"
						// onClickHandler={onApplyButtonClickedHandler}
						severity={EnhancedButtonPrimeReactSeverity.Secondary}
					// onClickHandler={() => setStateRunGetListAPICall(true)}
					/>
				</Grid>

			</Grid>


		</>
	);
};
